import Icon from '../components/Icon.vue'

Icon.register({
  'file-word': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM281.1 256c-5.6 0-10.5 3.9-11.5 9.5-24.2 111.4-21.8 118-21.6 129.2-0.8-5.4-5.6-29-29.6-129.4-1.3-5.4-6.1-9.2-11.7-9.2h-29.1c-5.6 0-10.4 3.7-11.7 9.1-22.1 90-27.8 112.5-29.4 122.7-0.9-12.7-5.4-44.2-21-122.2-1.1-5.7-6.1-9.7-11.8-9.7h-24.5c-7.7 0-13.4 7.1-11.7 14.6l37.8 168c1.2 5.5 6.1 9.4 11.7 9.4h37.1c5.5 0 10.3-3.8 11.6-9.1 23.2-93.1 24.5-96.2 25.6-110.5h0.5c4.8 29.3-0.2 7 25.6 110.5 1.3 5.3 6.1 9.1 11.6 9.1h38c5.6 0 10.5-3.8 11.7-9.3l38-168c1.7-7.6-4-14.7-11.7-14.7h-23.9zM384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z'
      }
    ]
  }
})
